import { segmentOptionStyles } from './segment-option.styles.esm.js';
import { segmentedControlGroupStyles } from './segmented-control-group.styles.esm.js';

var segmentedControlBase = {
  group: segmentedControlGroupStyles,
  segmentOption: segmentOptionStyles
};
var segmentedControlStyles = {
  base: segmentedControlBase
};

export { segmentedControlBase, segmentedControlStyles };
//# sourceMappingURL=segmented-control.styles.esm.js.map
